<div class="content">

    <div class="text-left mt-5">

        <h3>API's List</h3><br><br>

 
        <ul class="list-group list-group-item-light shadow">

            <li class="list-group-item list-group-item-action">
                <a routerLink="/apilist/joblist" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> List All Video Jobs</h5>
                </a>
            </li>

            <li class="list-group-item list-group-item-action">
                <a routerLink="/apilist/getjobDetails" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Get Video Job Details</h5>
                </a>
            </li>

            <li class="list-group-item list-group-item-action">
                <a routerLink="/apilist/ListImageBatchDetails" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> List All Image Batch Details</h5>
                </a>
            </li>

            <li class="list-group-item list-group-item-action">
                <a routerLink="/apilist/GetImageBatchDetails" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Get Image Batch details</h5>
                </a>
            </li>


            <li class="list-group-item list-group-item-action">
                <a routerLink="/websocket" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Get Job Status on WebSocket</h5>
                </a>
            </li>

            <li class="list-group-item list-group-item-action">
                <a routerLink="/webhook" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Get Job Status on Webhook</h5>
                </a>
            </li>


            <li class="list-group-item list-group-item-action">
                <a routerLink="/apilist/customerupdate" target="_blank">
                    <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Customer Update</h5>
                </a>
            </li>

        </ul><br><br>


        <h5>Storage API's</h5><br>

        <ul class="list-group list-group-item-light shadow">
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/storage-connect" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Storage Connect</h5>
              </a>
          </li>
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/storage-disconnect" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Storage Disconnect</h5>
              </a>
          </li>
  
           <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/storage-listfile" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Storage List Files</h5>
              </a>
          </li>
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/storage-batchjob" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Storage Batch Jobs</h5>
              </a>
          </li>
  
        </ul><br><br>
  
  
        <h5>Processing files from</h5><br>
  
        <ul class="list-group list-group-item-light shadow">
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/s3" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3</h5>
              </a>
          </li>
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/oci" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> OCI</h5>
              </a>
          </li>
  
           <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/google-drive" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive</h5>
              </a>
          </li>
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/dropbox" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox</h5>
              </a>
          </li>
  
          <li class="list-group-item list-group-item-action">
              <a routerLink="/apilist/local" target="_blank">
                  <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Local</h5>
              </a>
          </li>
  
        </ul><br><br>


       <!-- <h5>Auth API's</h5><br>

       <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/customerAuth" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Auth Customer</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/OCIAuth" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> OCI Auth</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/S3Auth" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3 Auth</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/dropboxAuth" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox Auth</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/googledriveAuth" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive Auth</h5>
            </a>
        </li>

      </ul><br><br> -->

      <!-- <h5>Batch API's</h5><br>

      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/OCIBatch" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> OCI Batch</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/S3Batch" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3 Batch</h5>
            </a>
        </li>

         <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/dropboxBatch" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox Batch</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/googledriveBatch" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive Batch</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/localBatch" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Local Batch job submission</h5>
            </a>
        </li>


      </ul><br><br> -->


      <!-- <h5>Submit Jobs using Public URLs</h5><br>


      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/videoJobSubmission" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Submit Video Job using public url (Optimization/Upscaling)</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/imageJobSubmission" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Image Job Submission using public url</h5>
            </a>
        </li>

      </ul><br><br> -->


      <!-- <h5>List Files API's</h5><br>


      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/oci-files" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> OCI List Files</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/s3-files" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3 List Files</h5>
            </a>
        </li>

         <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/dropbox-files" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox List Files</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/drive-files" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive List Files</h5>
            </a>
        </li>


      </ul><br><br> -->


      <!-- <h5>Disconnect API's</h5><br>


      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/oci-disconnect" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> OCI Disconnect</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/s3-disconnect" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3 Disconnect</h5>
            </a>
        </li>

         <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/dropbox-disconnect" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox Disconnect</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/drive-disconnect" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive Disconnect</h5>
            </a>
        </li>


      </ul><br><br> -->

  
      <h5>Local file upload</h5><br>

      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/createPreSignedUrl" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Create S3 Presigned URL</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/createMultipart" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Create multipart upload request</h5>
            </a>
        </li>

         <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/generatePresignedURL" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Generate presigned URL for parts</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/completeMultipartUpload" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Complete multipart upload</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/abortMultipartUpload" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Abort multipart</h5>
            </a>
        </li>

      </ul><br><br>

      <h5>Delete API's</h5><br>

      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/delete-video" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Delete Video</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/delete-image" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Delete Image</h5>
            </a>
        </li>

      </ul><br><br>


      <h5>LIVE Sessions</h5><br>

      <ul class="list-group list-group-item-light shadow">

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/create-session" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Create Session</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/get-session" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Get Session Details</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/list-session" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> List Session Details</h5>
            </a>
        </li>

        <li class="list-group-item list-group-item-action">
            <a routerLink="/apilist/get-region" target="_blank">
                <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> GetRegion</h5>
            </a>
        </li>

      </ul><br><br>



    </div>

</div>